export default "__VITE_ASSET__f486d4c4__"